import { Ref, ref } from 'vue';
import { GraphQLError } from '@/store/api';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type CallbackFunctionType = (...args: any[]) => Promise<unknown>;

type useSimpleStoreReturnType = {
  isRequestInProgress: Ref<boolean>;
  errorMessage: Ref<string>;
  errorText: Ref<string>;
  execute: CallbackFunctionType;
};

export default function useSimpleStore(fn: CallbackFunctionType, errorPrefix: string): useSimpleStoreReturnType {
  const isRequestInProgress = ref(false);
  const errorMessage = ref('');
  const errorText = ref('');

  const execute = async (...args: unknown[]) => {
    isRequestInProgress.value = true;
    errorMessage.value = '';
    errorText.value = '';

    try {
      await fn(...args);
    } catch (error) {
      console.error(error);
      errorMessage.value = errorPrefix;
      if (error instanceof GraphQLError) {
        errorText.value = 'Идентификатор ошибки: ' + error.requestId;
      }
    } finally {
      isRequestInProgress.value = false;
    }
  };

  return { isRequestInProgress, errorMessage, errorText, execute };
}

export function reuseSimpleStore(
  isRequestInProgress: Ref<boolean>,
  errorMessage: Ref<string>,
  errorText: Ref<string>,
  fn: CallbackFunctionType,
  errorPrefix: string,
): CallbackFunctionType {
  const execute = async (...args: unknown[]) => {
    isRequestInProgress.value = true;
    errorMessage.value = '';

    try {
      await fn(...args);
    } catch (error) {
      errorMessage.value = errorPrefix;
      if (error instanceof GraphQLError) {
        errorText.value = 'Идентификатор ошибки: ' + error.requestId;
      }
    } finally {
      isRequestInProgress.value = false;
    }
  };

  return execute;
}
